import { useState, useEffect, useCallback } from "react";

const KEY = "switchboard_saved";
const EVT = "sb-saved-changed";

export const getSaved = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch (e) {
    return [];
  }
};

const write = (arr) => {
  localStorage.setItem(KEY, JSON.stringify(arr));
  window.dispatchEvent(new Event(EVT));
};

export const toggleSaved = (slug) => {
  const cur = getSaved();
  const next = cur.includes(slug) ? cur.filter((s) => s !== slug) : [slug, ...cur];
  write(next);
  return next;
};

export const useBookmarks = () => {
  const [saved, setSaved] = useState(getSaved);
  useEffect(() => {
    const h = () => setSaved(getSaved());
    window.addEventListener(EVT, h);
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener(EVT, h);
      window.removeEventListener("storage", h);
    };
  }, []);
  const toggle = useCallback((slug) => setSaved(toggleSaved(slug)), []);
  return { saved, toggle, isSaved: (slug) => saved.includes(slug) };
};
